// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es7.map.from.js
// module id = 1010
// module chunks = 0